import React, { useRef, useState } from 'react'
import cls from './business.module.scss'
import { ReactComponent as Icon } from '@/shared/assets/downArrow.svg'
import { classNames } from '@/shared/lib/utils/classNames'
import useClickOutside from '@/shared/lib/hooks/useClickOutside'

export const BusinessInfo = () => {
    const [open, setOpen] = useState(false)
    const infoRef = useRef()

    useClickOutside(infoRef, () => {
        setOpen(false)
    })

    return (
        <div
            ref={infoRef}
            className={cls.container}
        >
            <div
                className={classNames(cls.menu, [], {
                    [cls.close]: !open,
                })}
            >
                <h3>Business Information</h3>
                <table>
                    <tbody className={cls.tableBody}>
                        {/* <tr>
                            <th scope='row'>ID</th>
                            <td>53870093</td>
                        </tr> */}
                        {/* <tr>
                            <th scope='row'>TIN</th>
                            <td>2121530565</td>
                        </tr> */}

                        <tr>
                            <th scope="row">Name</th>
                            <td>PAEKOS ENTERPRISES LTD</td>
                        </tr>
                        <tr>
                            <th scope="row">Registration Number:</th>
                            <td>ΗΕ 482484</td>
                        </tr>
                        <tr className={cls.large}>
                            <th scope="col">Head office</th>
                            <td>Efesou 9, Paralimni 5280, Ammochostos, Cyprus</td>
                        </tr>
                        {/* <tr className={cls.large}>
                            <th scope="col">Date of creation</th>
                            <td>Saturday, 26 June 2021</td>
                        </tr> */}
                        {/* <tr className={cls.large}>
                            <th scope="col">SK NACE</th>
                            <td>
                                according to the financial statements: 62010 Computer Programming according to the
                                Statistical Office of the Slovak Republic: 62090 Other information services information
                                technology and computers
                            </td>
                        </tr> */}
                    </tbody>
                </table>
            </div>
            <button
                onClick={() => setOpen(!open)}
                className={classNames(cls.BusinessInfo, [], {
                    [cls.open]: open,
                })}
            >
                Business Info
                <Icon
                    type="select-arrow"
                    className={classNames(cls.arrow, [], {
                        [cls.open]: open,
                    })}
                    stroke="black"
                />
            </button>
        </div>
    )
}
